export default "__VITE_ASSET__Dz$SsPyH__"